import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import PdfTextBlockTop from '../TextBlocks/PdfTextBlockTop';
import PdfTextBlockLeft from '../TextBlocks/PdfTextBlockLeft';
import PdfTextBlockBottom from '../TextBlocks/PdfTextBlockBottom';

import { CONTROL_LEVELS_PDF, PDF_BLOCK_HEADING, PDF_BLOCK_TEXT, PDF_GRAY } from '../../../../constants';

const MainSummary = ({ data }) => {
    return (
        <View
            style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "stretch",
                marginBottom: "20px"
            }}
        >
            <View
                style={{
                    width: "33%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "10px"
                }}
            >
                <PdfTextBlockTop
                    title="Factory"
                    text={data.id}
                    disableBottomBorder={true}
                    fontSmaller
                    fontNormal
                />
                <PdfTextBlockTop
                    title="Job ID"
                    text={data.id}
                    fontSmaller
                    fontNormal
                />
            </View>
            <View
                style={{
                    width: "33%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "10px"
                }}
            >
                <PdfTextBlockTop
                    title="Control Cycle label"
                    text={data.label ? data.label : "-"}
                    fontSmaller
                    fontNormal
                    disableBottomBorder={true}
                />
                <PdfTextBlockTop
                    title="Control Level"
                    text={data.control_level ? CONTROL_LEVELS_PDF.find(item => item.value === data.control_level)?.label : "-"}
                    fontSmaller
                    fontNormal
                />
            </View>
            <View
                style={{
                    width: "33%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "10px"
                }}
            >
                <PdfTextBlockLeft
                    title="%Value"
                    text={
                        data.quantity ? data.quantity.quantity
                            : data.percentage ? `${data.percentage.percentage}%`
                                :
                                "-"
                    }
                    disableBottomBorder={true}
                    fontSmaller
                    fontNormal
                    textStyles={{
                        textAlign: "center"
                    }}
                />
                <PdfTextBlockTop
                    disableBottomBorder
                    title="AQL"
                    text="J00463"
                    fontSmaller
                    fontNormal
                    hideText
                />
                <View
                    style={{
                        flexDirection: "row"
                    }}
                >
                    <PdfTextBlockBottom
                        title="Critical"
                        text={
                            data.aql ? data.aql.critical : "-"
                        }
                        disableTopBorder={true}
                        disableRightBorder={true}
                        fontSmaller
                        fontNormal
                        textStyles={{
                            textAlign: "center"
                        }}
                    />
                    <PdfTextBlockBottom
                        title="Major"
                        text={
                            data.aql ? data.aql.major : "-"
                        }
                        disableTopBorder={true}
                        disableRightBorder={true}
                        fontSmaller
                        fontNormal
                        textStyles={{
                            textAlign: "center"
                        }}
                    />
                    <PdfTextBlockBottom
                        title="Minor"
                        text={
                            data.aql ? data.aql.minor : "-"
                        }
                        fontSmaller
                        fontNormal
                        disableTopBorder={true}
                        textStyles={{
                            textAlign: "center"
                        }}
                    />
                </View>
            </View>


        </View>
    )
}

export default MainSummary